import React, { useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import Typewriter from "typewriter-effect";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import FilePreviewComponent from "./file-preview-component";
import Paper from "@material-ui/core/Paper";
import { CategoryButton, ChoiceButton } from "./index";
import NewTabUrlField from "./url-field";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const useStyles = makeStyles((theme) => ({
  modal: {
    minWidth: "30%",
  },
  dialogPaper: {
    minHeight: "70vh",
    maxHeight: "90vh",
  },
  additionalFileButton: {
    marginTop: 10,
    minHeight: 50,
    color: "#FFFFFF",
    background: "#7B0000",
    textTransform: "none",
    width: "25%",
  },
  canvas: {
    marginTop: 0,
    display: "flex",
    justifyContent: "center",
  },
  paper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    marginBottom: 20,
    marginTop: 0,
  },
  content: {
    display: "flex",
    flexDirection: "row",
    flex: 5,
  },
  linkContainer: {
    display: "flex",
    flex: 1,
    minWidth: "20vw",
    justifyContent: "center",
  },
  link: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "90%",
    background: "#C4C4C4",
    padding: 20,
  },
  fileComponentContainer: {
    display: "flex",
    flex: 5,
    alignItems: "flex-end",
  },
  fileComponent: {
    height: "100%",
    width: "100%",
    background: "#C4C4C4",
    padding: 20,
  },
}));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography style={{ width: "90%" }} variant="h3">
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

export const AnswerLinkPopup = ({
  linkArray,
  title,
  content,
  visible,
  closeModal,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [fileType, setFileType] = useState("");
  const [fileUrl, setFileUrl] = useState("");

  const handleClickOpen = () => {
    if (linkArray.length === 1) {
      setSelectedFile(linkArray[0]);
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    if (title) {
      closeModal();
    }
    setSelectedFile("");
  };

  const setSelectedFile = (url) => {
    if (url.includes("audio")) {
      setFileType("audio");
    } else if (url.includes("video")) {
      setFileType("video");
    } else if (url.includes("pdf")) {
      setFileType("pdf");
    } else if (url.includes("image")) {
      setFileType("image");
    } else {
      setFileType("");
    }
    setFileUrl(url);
  };

  if (linkArray.length === 0 && !title) {
    return null;
  } else if (linkArray.length === 1 && !title) {
    return (
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ChoiceButton label="Attachment" blue onClick={handleClickOpen} />
        </div>
        <Dialog
          classes={{ paper: classes.dialogPaper }}
          maxWidth="md"
          fullWidth={fileType === "pdf"}
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <DialogTitle id="customized-dialog-title" onClose={handleClose}>
            Attachment
          </DialogTitle>
          <DialogContent>
            <NewTabUrlField url={fileUrl} />
            <FilePreviewComponent type={fileType} url={fileUrl} />
          </DialogContent>
        </Dialog>
      </div>
    );
  } else {
    return (
      <div>
        {!title ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ChoiceButton label="Attachment" blue onClick={handleClickOpen} />
          </div>
        ) : null}
        <Dialog
          maxWidth="md"
          fullWidth={fileType === "pdf"}
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={visible || open}
          classes={{ paper: classes.modal }}
        >
          <DialogTitle id="customized-dialog-title" onClose={handleClose}>
            {title ? title : "Attachment"}
          </DialogTitle>
          <DialogContent>
            {content ? (
              <Typewriter
                options={{
                  cursor: null,
                  strings: content,
                  autoStart: true,
                  delay: 18,
                }}
              />
            ) : null}
            {linkArray.length ? (
              <div className={classes.canvas}>
                <div className={classes.paper}>
                  <div className={classes.content}>
                    <div className={classes.linkContainer}>
                      <Paper className={classes.link}>
                        <div style={{ flex: 9 }}>
                          {linkArray.map((link, index) => (
                            <CategoryButton
                              label={`Attachment ${index + 1}`}
                              red
                              onClick={() => setSelectedFile(link)}
                            />
                          ))}
                        </div>
                      </Paper>
                    </div>
                    {fileUrl ? (
                      <div className={classes.fileComponentContainer}>
                        <Paper className={classes.fileComponent}>
                          <NewTabUrlField url={fileUrl} />
                          <FilePreviewComponent url={fileUrl} type={fileType} />
                        </Paper>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            ) : null}
          </DialogContent>
        </Dialog>
      </div>
    );
  }
};
